import { render, staticRenderFns } from "./ServiceOrderCommentLineComponent.vue?vue&type=template&id=6b96da40&"
import script from "./ServiceOrderCommentLineComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderCommentLineComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports